import React, { Component } from "react";
import { isMobile } from "react-device-detect";
import { TextField, Button, CircleProgress } from "reactackle";
import PhotoUploadPass from "../FieldsComponents/PhotoUpload/PhotoUploadPass";
import SignPad from "../FieldsComponents/SignPad/SignPad";
import moment from "moment";
import _ from "lodash";

class RemitRegistration extends Component {
  state = {
    data: {
      path: "",
      payload: {
        senderName: "",
        senderAddress: "",
        idType: "PASSPORT",
        idNumber: "",
        exchId: "",
        mobile: this.props.cellPhone,
        status: "PENDING",
        exchange: "Agrani Exchange Pte Ltd",
        appDate: moment().format("DD MMM YYYY"),
        idVerified: false,
        inPersonVerified: false,
        comments: "",
        internalNotes: ""
      }
    },
    stage: "genInput"
  };

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    // console.log(
    //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
    // );
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(prevState => {
        if (prevState && prevState.data.payload !== null) {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                ...tmpState
              }
            }
          };
        } else {
          return {
            ...prevState,
            data: {
              path: prevState.data.path,
              payload: {
                ...tmpState
              }
            }
          };
        }
      });
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          ...tmpState
        };
      });
    }
  };

  getRow = (heading, value) => {
    return (
      <tr>
        <td>{heading}</td>
        <td>{value}</td>
      </tr>
    );
  };

  getRegFormField = (fieldId, placeholder, caption, multiline) => {
    return (
      <div>
        <div
          style={{
            padding: "1px",
            textAlign: "right",
            border: "1px solid gainsboro",
            borderRadius: isMobile ? "5px" : "0px",
            backgroundColor: "white",
            zIndex: "-9",
            margin: "5px",
            fontSize: "12px"
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row"
            }}
          >
            <div
              style={{
                width: "30%",
                lineHeight: "12px",
                textAlign: "left",
                paddingLeft: "5px",
                margin: "auto"
              }}
            >
              {caption}
            </div>
            <div
              style={{
                width: "70%",
                border: "1px solid gainsboro",
                borderRadius: "5px",
                borderTopLeftRadius: "0px",
                borderBottomLeftRadius: "0px",
                margin: "2px"
              }}
            >
              <TextField
                value={this.state.data.payload[fieldId]}
                onChange={e => {
                  this.stateChangeHandler(e.value, fieldId, true);
                  if (fieldId === "textNameBangla") {
                    this.getBanglaImage(e.value);
                  }
                }}
                multiline={multiline}
                fullWidth
                placeholder={placeholder}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  getRegFormTwinButtons = (fieldId, caption, btn1Text, btn2Text) => {
    return (
      <div>
        <div
          style={{
            padding: "1px",
            textAlign: "right",
            border: "1px solid gainsboro",
            borderRadius: isMobile ? "5px" : "0px",
            backgroundColor: "white",
            zIndex: "-9",
            margin: "5px",
            fontSize: "12px"
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row"
            }}
          >
            <div
              style={{
                width: "30%",
                lineHeight: "12px",
                textAlign: "left",
                paddingLeft: "5px",
                margin: "auto"
              }}
            >
              {caption}
            </div>
            <div
              style={{
                width: "70%",
                display: "flex",
                flexDirection: "row"
              }}
            >
              <Button
                text={btn1Text}
                colorScheme={
                  this.state.data.payload[fieldId] === btn1Text
                    ? "primary"
                    : "white"
                }
                onPress={() => {
                  this.stateChangeHandler(btn1Text, fieldId, true);
                  this.props.setScroll(true);
                }}
              />
              <Button
                text={btn2Text}
                colorScheme={
                  this.state.data.payload[fieldId] === btn2Text
                    ? "primary"
                    : "white"
                }
                onPress={() => {
                  this.stateChangeHandler(btn2Text, fieldId, true);
                  this.props.setScroll(true);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  getChoiceButton = (label, stateVal, stateFldId, iconClass, colorIt) => {
    return (
      <div
        style={{
          width: "50%",
          padding: "1px",
          textAlign: "center",
          border: "1px solid gainsboro",
          borderRadius: isMobile ? "5px" : "0px",
          backgroundColor: colorIt ? "rgb(30, 101, 144)" : "white",
          margin: "auto",
          padding: "6px",
          fontWeight: "bold",
          color: colorIt ? "white" : "black",
          fontSize: "12px",
          minWidth: "80px",
          maxWidth: "80px"
        }}
        onClick={() => {
          this.stateChangeHandler(stateVal, stateFldId, false);
          this.props.setScroll(true);
        }}
      >
        <div>
          <i className={iconClass}></i> {label}
        </div>
      </div>
    );
  };

  getNextBack = (stageBack, stageNext) => {
    return (
      <div>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td style={{ border: "0px" }}>
                <div
                  style={{
                    textAlign: "center",
                    width: "100%"
                  }}
                >
                  <div
                    style={{
                      width: "50%",
                      padding: "1px",
                      textAlign: "center",
                      border: "1px solid gainsboro",
                      borderRadius: isMobile ? "5px" : "0px",
                      backgroundColor: "rgb(30, 101, 144)",
                      margin: "auto",
                      padding: "6px",
                      fontWeight: "bold",
                      color: "white",
                      fontSize: "12px",
                      minWidth: "140px"
                    }}
                    onClick={() => {
                      this.stateChangeHandler(stageBack, "stage", false);
                      this.props.setScroll(true);
                    }}
                  >
                    <div>
                      <i className="fa fa-arrow-left"></i> BACK
                    </div>
                  </div>
                </div>
              </td>
              <td style={{ border: "0px" }}>
                <div
                  style={{
                    textAlign: "center",
                    width: "100%"
                  }}
                >
                  <div
                    style={{
                      width: "50%",
                      padding: "1px",
                      textAlign: "center",
                      border: "1px solid gainsboro",
                      borderRadius: isMobile ? "5px" : "0px",
                      backgroundColor: "rgb(30, 101, 144)",
                      margin: "auto",
                      padding: "6px",
                      fontWeight: "bold",
                      color: "white",
                      fontSize: "12px",
                      minWidth: "140px"
                    }}
                    onClick={() => {
                      this.stateChangeHandler(stageNext, "stage", false);
                      this.props.setScroll(true);
                    }}
                  >
                    <div>
                      NEXT <i className="fa fa-arrow-right"></i>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  getGenInputForm = () => {
    return (
      <div>
        <p
          style={{
            backgroundColor: "orange",
            padding: "5px",
            fontWeight: "bold"
          }}
        >
          Registration is Easy (দয়াকরে নিচের তথ্যগুলো ভালকরে দেখে নিন, সবকিছু
          ঠিক থাকলে নিচের "কনফার্ম" বাটনে চাপুন।):
        </p>
        <p>
          <div>
            {this.getRegFormField(
              "senderName",
              "আবেদনকারীর নাম (ইংরেজিতে)",
              "FULL NAME",
              false
            )}
          </div>
          <div>
            {this.getRegFormField(
              "senderAddress",
              "আবেদনকারীর নাম (ইংরেজিতে)",
              "ADDRESS",
              true
            )}
          </div>
          <div>
            {this.getRegFormTwinButtons(
              "idType",
              "ID TYPE",
              "PASSPORT",
              "LICENSE"
            )}
          </div>
          <div>
            {this.getRegFormField(
              "idNumber",
              "আবেদনকারীর নাম (ইংরেজিতে)",
              "ID #",
              false
            )}
          </div>
          <div>
            {this.getRegFormField(
              "exchId",
              "আবেদনকারীর নাম (ইংরেজিতে)",
              "REMIT ID",
              false
            )}
          </div>
        </p>
        <p>
          <div>
            {this.getChoiceButton(
              "NEXT",
              "photoInput",
              "stage",
              "fa fa-arrow-right",
              true
            )}
          </div>
        </p>
      </div>
    );
  };

  getReviewPage = () => {
    return (
      <div>
        {!this.state.generatingStatement && (
          <div>
            <div
              style={{
                backgroundColor: "orange",
                padding: "5px",
                fontWeight: "bold",
                marginBottom: "10px"
              }}
            >
              Please carefully review the following information and press the
              confirm button (দয়াকরে নিচের তথ্যগুলো ভালকরে দেখে নিন, সবকিছু ঠিক
              থাকলে নিচের "কনফার্ম" বাটনে চাপুন।):
            </div>

            <table className="table table-bordered table-striped">
              <tbody>
                {this.getRow("FULL NAME", this.state.data.payload.senderName)}
                {this.getRow("ADDRESS", this.state.data.payload.senderAddress)}

                {this.getRow("ID Type", this.state.data.payload.idType)}

                {this.getRow("ID #", this.state.data.payload.idNumber)}

                {this.getRow("Mobile No", this.state.data.payload.mobile)}
              </tbody>
            </table>
            <p></p>
            <div>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ border: "0px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          width: "100%"
                        }}
                      >
                        <div
                          style={{
                            width: "50%",
                            padding: "1px",
                            textAlign: "center",
                            border: "1px solid gainsboro",
                            borderRadius: isMobile ? "5px" : "0px",
                            backgroundColor: "rgb(30, 101, 144)",
                            margin: "auto",
                            padding: "6px",
                            fontWeight: "bold",
                            color: "white",
                            fontSize: "12px",
                            minWidth: "140px"
                          }}
                          onClick={() => {
                            this.stateChangeHandler("genInput", "stage", false);
                          }}
                        >
                          <div>
                            <i className="fa fa-arrow-left"></i> CHANGE
                          </div>
                        </div>
                      </div>
                    </td>
                    <td style={{ border: "0px" }}>
                      <div
                        style={{
                          textAlign: "center",
                          width: "100%"
                        }}
                      >
                        <div
                          style={{
                            width: "50%",
                            padding: "1px",
                            textAlign: "center",
                            border: "1px solid gainsboro",
                            borderRadius: isMobile ? "5px" : "0px",
                            backgroundColor: "rgb(30, 101, 144)",
                            margin: "auto",
                            padding: "6px",
                            fontWeight: "bold",
                            color: "white",
                            fontSize: "12px",
                            minWidth: "140px"
                          }}
                          onClick={() => {
                            confirm(
                              "Are you sure you would like to submit this applicatino?"
                            ) && this.submitRegistration();
                          }}
                        >
                          <div>
                            SUBMIT <i className="fa fa-arrow-right"></i>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    );
  };

  getPhotoInputForm = () => {
    return (
      <div>
        <div>
          <div
            style={{
              backgroundColor: "orange",
              padding: "5px",
              fontWeight: "bold"
            }}
          >
            Please upload clear photos of your ID documents
          </div>
          <p>
            <div style={{ margin: "0px", textAlign: "center" }}>
              <PhotoUploadPass
                title1={"PASSPORT PHOTO"}
                title2={"লোড পাসপোর্ট ফটো"}
                images={this.state.idImage}
                fieldName={"idImage"}
                isPayload={false}
                stateChangeHandler={this.stateChangeHandler}
                disabled={false}
              />
              <PhotoUploadPass
                title1={"WORK PERMIT PHOTO (FRONT)"}
                title2={"লোড পারমিটের সামনের ফটো"}
                images={this.state.wpFrontImage}
                fieldName={"wpFrontImage"}
                isPayload={false}
                stateChangeHandler={this.stateChangeHandler}
                disabled={false}
              />
              <PhotoUploadPass
                title1={"WORK PERMIT PHOTO (BACK)"}
                title2={"লোড পারমিটের পেছনের ফটো"}
                images={this.state.wpBackImage}
                fieldName={"wpBackImage"}
                isPayload={false}
                stateChangeHandler={this.stateChangeHandler}
                disabled={false}
              />
            </div>

            <input
              type="file"
              accept="image/*"
              id="uploader"
              onChange={evt => {
                console.log("clicked");
                //console.log("triggering main function");
                event.preventDefault();
                //console.log(evt.target.result);
                if (evt.target.files[0]) {
                  this.idScanTo64(evt.target.files);
                } else {
                  console.log("gotcha");
                }
              }}
              style={{
                visibility: "hidden",
                height: "0px"
              }}
            />
          </p>
          {this.getNextBack("genInput", "review")}
        </div>
      </div>
    );
  };

  createRemitRegRec = () => {
    let cloudPath = "agraniRegs/";
    let recObj = _.cloneDeep(this.state.data.payload);
    recObj.exchange = "Agrani Exchange Pte Ltd";
    var passApp = this.props.firebase.db.ref("/" + cloudPath).push();
    passApp
      .set(recObj)
      .catch(err => {
        console.log(err);
        return console.log("some error: " + err);
      })
      .then(err => {
        //clear the bucket
        this.props.firebase.db
          .ref(
            "/remSvc" + "/" + this.props.cellPhone + "/remRegs/" + passApp.key
          )
          .once("value")
          .then(snap => {
            snap.ref.set(recObj);
            cloudPath = "primeRegs/";
            recObj.exchange = "Prime Exchange Co. Pte Ltd";
            var passApp2 = this.props.firebase.db.ref("/" + cloudPath).push();
            passApp2
              .set(recObj)
              .catch(err => {
                console.log(err);
                console.log("some error: " + err);
              })
              .then(err => {
                //clear the bucket
                this.props.firebase.db
                  .ref(
                    "/remSvc" +
                      "/" +
                      this.props.cellPhone +
                      "/remRegs/" +
                      passApp2.key
                  )
                  .once("value")
                  .then(snap => {
                    snap.ref.set(recObj);
                  })
                  .catch(err => {
                    console.log(err);
                    console.log("some error: " + err);
                  })
                  .then(err => {
                    console.log("updated");
                  });
              });
          })
          .catch(err => {
            console.log(err);
            console.log("some error: " + err);
          })
          .then(err => {
            console.log("updated");
          });
      });
  };

  getEmailText = () => {
    let emTxt = "Dear Sir \n Please see below my application";
    emTxt = emTxt + " for registration as per the following details: \n";
    emTxt = emTxt + "\n";
    emTxt = emTxt + "\n";
    emTxt = emTxt + "Name: " + this.state.data.payload.senderName + " \n";
    emTxt = emTxt + "Adress: " + this.state.data.payload.senderAddress + " \n";
    emTxt = emTxt + "Id Type: " + this.state.data.payload.idType + " \n";
    emTxt = emTxt + "ID #: " + this.state.data.payload.idNumber + " \n";
    emTxt = emTxt + "Mobile: " + this.state.data.payload.mobile + " \n";
    emTxt =
      emTxt + "Application Date: " + this.state.data.payload.appDate + " \n";

    emTxt = emTxt + "\n";
    emTxt = emTxt + "\n";

    emTxt =
      emTxt + "I have attached with this email the following documents: \n";
    emTxt =
      emTxt +
      " - Passport \n - Work Permit (Front & Back) \n - Proof of payment \n";
    emTxt =
      emTxt +
      "For any further information please rechout to me at my phone number provided above.\n";
    emTxt = emTxt + "\n";
    emTxt = emTxt + "\n Note: \n";
    emTxt = emTxt + "";
    emTxt = emTxt + "- This is a system generated email. \n";
    emTxt =
      emTxt +
      " - Information provided above is as per the data provided by users, and it is the responsibility of users to ensure correct input of all information. \n";
    emTxt =
      emTxt +
      "- For any further information please contact the applicant directly \n";
    emTxt = emTxt + "\n";
    emTxt = emTxt + "\n";
    return emTxt;
  };

  getHtmlRow = (heading, value) => {
    return (
      "<tr><td style='border: 1px solid black;padding: 5px'>" +
      heading +
      "</td><td style='border: 1px solid black;padding: 5px'>" +
      value +
      "</td></tr>"
    );
  };

  getEmailHtml = () => {
    let emTxt = "<p>Dear Sir </p><p> Please find below my application for ";
    emTxt =
      emTxt + " remittance registeration as per the following details: </p>";
    emTxt = emTxt + "<p></p>";
    emTxt =
      emTxt +
      "<table style='border: 1px solid black;max-width: 450px;min-width:450px'><tbody>";
    emTxt = emTxt + this.getHtmlRow("Name", this.state.data.payload.senderName);
    emTxt =
      emTxt + this.getHtmlRow("Address", this.state.data.payload.senderAddress);
    emTxt = emTxt + this.getHtmlRow("ID No.", this.state.data.payload.idNumber);

    emTxt =
      emTxt + this.getHtmlRow("Remittance ID", this.state.data.payload.exchId);
    emTxt =
      emTxt +
      this.getHtmlRow("Application Date", this.state.data.payload.appDate);

    emTxt = emTxt + "</tbody></table>";
    emTxt = emTxt + "<p></p><p></p>";

    emTxt =
      emTxt +
      "<p>I have attached with this email the photos of following documents:</p>";
    emTxt =
      emTxt + "<ul><li>Passport</li><li>Work Permit (Front & Back)</li></ul>";
    emTxt =
      emTxt +
      "<p>For any further information please rechout to me at my phone number.</p>";
    emTxt = emTxt + "<p></p>";
    emTxt = emTxt + "<p><b>Note:</b></p>";
    emTxt = emTxt + "<p></p>";
    emTxt = emTxt + "<p><ul><li>This is a system generated email.</li>";
    emTxt =
      emTxt +
      "<li>Information provided in this application, is as per the data provided by users, and it is the responsibility of users to ensure correct input of all information.</li>";
    emTxt =
      emTxt +
      "<li>For any further information please contact the applicant directly</li>";
    emTxt = emTxt + "</p>";
    emTxt = emTxt + "<p></p>";
    return emTxt;
  };

  submitRegistration = () => {
    let emailParams = {
      from: '"BCS Registration Request" helper@brooklynzcommunitysupport.com', // sender address
      to: "ahmed_fayyaz@outlook.com", // list of receivers
      subject:
        "Registeration Request [ " +
        this.state.data.payload.senderName +
        " | " +
        this.state.data.payload.idNumber +
        " | " +
        this.props.cellPhone +
        " ]", // Subject line
      attachments: [],
      text: this.getEmailText(), // plain text body
      html: this.getEmailHtml() // html body
    };
    if (window.location.hostname !== "localhost") {
      emailParams.attachments.push({
        filename: "id.jpg",
        path: this.state.idImage[0].b64
      });

      emailParams.attachments.push({
        filename: "permitFront.jpg",
        path: this.state.wpFrontImage[0].b64
      });

      emailParams.attachments.push({
        filename: "permitBack.jpg",
        path: this.state.wpBackImage[0].b64
      });
    }

    //get state updated with calc fields
    Promise.all([
      this.stateChangeHandler(true, "generatingStatement", false)
    ]).then(res => {
      //console.log("test test: " + res[1]);

      this.props
        .onSendEmail(emailParams)
        .then(emailResp => {
          //this.saveHandler();
          this.createRemitRegRec();
          //   let suppNotifyText =
          //     "New passport form generated by " +
          //     this.state.data.payload.textName +
          //     " (" +
          //     this.state.data.payload.phoneNumber +
          //     ").";
          //this.props.onNotifyUsers(suppNotifyText, ["94562455"]);
          this.stateChangeHandler(false, "generatingStatement", false);
          this.stateChangeHandler("genInput", "stage", false);

          //   this.props.onAddRecord({
          //     path: "myPassApplication",
          //     payload: {}
          //   });
        })
        .catch(err => {
          console.log("Salaaa error: " + err);
          this.stateChangeHandler(false, "generatingStatement", false);
        });
    });
    //request new statement
    //once req completed show the stop loader and show statement
  };

  getStatementLoader = () => {
    return (
      <div
        style={{
          textAlign: "center",
          paddingTop: "10px"
        }}
      >
        <CircleProgress
          indeterminate
          subtitle="Submitting application... please be patient as it can take upto a minute (একটু অপেক্ষা করুন, ফরম ইমেইল হতে এক মিনিটের মতো লাগতে পারে।)"
          circleSize={40}
          strokeSize={5}
          labelPositionY="bottom"
          labelPositionX="center"
        />
      </div>
    );
  };

  getRegRecs = () => {
    if (this.props.myRemitRegs && this.props.myRemitRegs.length > 0) {
      return this.props.myRemitRegs.map(reg => {
        return (
          <table className="table table-bordered">
            <tbody>
              <tr>
                <td style={{ backgroundColor: "white" }}>Exchange</td>
                <td style={{ backgroundColor: "white" }}>{reg.exchange}</td>
              </tr>
              <tr>
                <td style={{ backgroundColor: "white" }}>Status</td>
                <td style={{ backgroundColor: "white" }}>{reg.status}</td>
              </tr>
            </tbody>
          </table>
        );
      });
    }
  };

  getRegStatus = () => {
    return (
      <div>
        {this.props.myRemitRegs && this.props.myRemitRegs.length > 0 && (
          <p>
            <br />
            <div>Current Registration Status:</div>
            <div style={{ margin: "10px" }}>{this.getRegRecs()}</div>
          </p>
        )}
      </div>
    );
  };

  getMainContent = () => {
    if (!this.props.myRemitRegs || this.props.myRemitRegs.length === 0) {
      return (
        <div>
          {this.state.generatingStatement && this.getStatementLoader()}
          <div>{this.state.stage === "genInput" && this.getGenInputForm()}</div>
          <div>
            {this.state.stage === "photoInput" && this.getPhotoInputForm()}
          </div>
          <div>{this.state.stage === "review" && this.getReviewPage()}</div>
        </div>
      );
    } else {
      return <div>{this.getRegStatus()}</div>;
    }
  };

  render() {
    return <div>{this.getMainContent()}</div>;
  }
}

export default RemitRegistration;



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/RemitRegistration.jsx